// src/experiments/special.mjs

/**
 * @type {Experiment}
 */
export const SpecialExperiment = {
  id: 'special',
  type: 'recurrence',
  name: 'Overskriv længde af special gentagelsesvirkning i år',
  exclusive: false,
  allowMultiple: false, // 🚨 Tillader eksplicit IKKE at køre flere gange!
  
  /**
   * @param {AppState} appState 
   * @param {string[]} args Parametre sendt med fra URL'en (f.eks. ['20'] eller ['full'])
   * @returns {void}
   */
  init(appState, args = []) {
    const rawValue = args[0];
    if (!rawValue) return;

    const duration = Number(rawValue);

    console.log(`[Eksperiment] Rekonfigurerer SPECIAL_EXT til ${duration} år...`);

    // Nye, længere værdier der skal overskrive standarden
    /** @type {{ years: number }} */
    const newSpecial = Object.freeze({ years: duration });
    
    // Injicer værdierne direkte ind i statens konfiguration
    appState.updateConfig('special_ext', newSpecial);
  }
};